import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { T, useTranslate } from '@tolgee/react'
import { Field } from 'react-final-form'

interface UrlFieldProps {
  disabled?: boolean
}

export function UrlField({ disabled = false }: UrlFieldProps) {
  const { t } = useTranslate()

  return (
    <Field name='url'>
      {({ input }) => (
        <div>
          <Label htmlFor={input.name} variant='dialog-field'>
            <T keyName='serviceRegistry.dialog.fields.url.label' />*
          </Label>
          <Input
            placeholder={t('serviceRegistry.dialog.fields.url.placeholder')}
            disabled={disabled}
            required
            {...input}
          />
        </div>
      )}
    </Field>
  )
}
